export const sortWithNullsAtEnd = (arr: any) => {
  const nulls = arr.filter((x: any) => x.ord == null);
  const values = arr.filter((x: any) => x.ord != null).sort((a: any, b: any) => a.ord - b.ord);
  return [...values, ...nulls];
};
